import React, { FC } from "react";

import { isEmpty } from "@Utils";

import styles from "./certificate.module.scss";
import useCertificate from "./useCertificate";
import { BadgeIcon } from "./HelperComponents";

const Certificate: FC = () => {
    const {
        previewCertificateImage = "",
        name,
        title,
        wordUsedForCourse,
    } = useCertificate();

    if (isEmpty(previewCertificateImage)) return null;

    return (
        <div className={styles.root}>
            <div className={styles.title}>
                <h3>{title || "Get certified!"}</h3>
                <BadgeIcon />
            </div>

            <div className={styles.contentWrapper}>
                <img src={previewCertificateImage} alt="certificate" />
                <div>
                    <p>
                        This {wordUsedForCourse} further helps you make your
                        mark! You will receive a certificate, signed and
                        addressed personally by your instructor
                    </p>
                    <h4>- {name}</h4>
                </div>
            </div>
        </div>
    );
};

export default Certificate;
